import { render, staticRenderFns } from "./BrokersTopLeftChartsContainer.vue?vue&type=template&id=87c8f500&scoped=true&"
import script from "./BrokersTopLeftChartsContainer.vue?vue&type=script&lang=js&"
export * from "./BrokersTopLeftChartsContainer.vue?vue&type=script&lang=js&"
import style0 from "./BrokersTopLeftChartsContainer.vue?vue&type=style&index=0&id=87c8f500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c8f500",
  null
  
)

export default component.exports